<template>
  <el-dialog
    :visible.sync="isneedLogin"
    custom-class="dialog"
    :close-on-press-escape="false"
    :show-close="false"
    :before-close="closeDialog"
    >
    <div class="first-floor">
      <div class="label">
        <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
      </div>
      <div class="label">
        <el-input v-model="validation" placeholder="请输入图形验证码" maxlength="4"></el-input>
        <div @click="refreshCode">
          <Validation :identify-code="identifyCode" class="Validation" />
        </div>
      </div>
    </div>
    <div class="first-floor">
      <div class="label">
        <el-input v-model="form.sms_code" placeholder="请输入验证码" maxlength="6"></el-input>
        <el-button class="codeBtn" :disabled="countTime < 60" @click="sendSMS">{{countTime >= 60 ? '获取验证码' : countTime + 's'}}</el-button>
      </div>
    </div>
    <el-button class="loginBtn" type="success" :loading="isloading" @click="handleLogin">{{isloading ? '登录中...' : '登录'}}</el-button>
    <span class="register" @click="goregister">注册</span>
  </el-dialog>
</template>

<script>
import Validation from './validation.vue'
import { isPhone } from '@/util/utils.js'
import { sendSms, login} from '@/api/login.js'
export default {
  name: 'Login',
  components:{ 
    Validation
  },
  props: {
    isneedLogin: false
  },
  data() {
    return {
      dialogVisible: true,
      form: {
        mobile: '',
        sms_code: ''
      },
      validation:'',
      identifyCode: '',
      identifyCodes: '1234567890abcdefjhijklinopqrsduvwxyz',
      countTime: 60,
      interval: null,
      isClickSMS: false,
      isClickLogin: false,
      isloading: false
    }
  },
  computed:{ },
  watch:{
    isneedLogin(olddata, newdata) {
      if (olddata != newdata) {
        this.form = {
          mobile: '',
          sms_code: ''
        }
        this.validation = ''
        this.refreshCode()
      }
    }
  },
  created() {
      
  },
  mounted() {
    console.log('mounted')
    this.refreshCode()
  },
  methods: {
    refreshCode() {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode +=
          this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    goregister() {
      this.$emit('goregister', true)
    },
    closeDialog() {
      this.$emit('needLogin', false)
    },
    sendSMS() {
      if (this.isClickSMS) return
      this.isClickSMS = true
      if (!isPhone(this.form.mobile)) {
        this.$message('请输入手机号')
        this.isClickSMS = false
        return
      }
      if (this.validation !== this.identifyCode) {
        this.$message('验证码错误')
        this.isClickSMS = false
        return
      }
      if (this.countTime >= 60 ) {
        sendSms({
          mobile: this.form.mobile
        }).then(res => {
          if (res.result === 1) {
            this.countTime--
            this.interval = setInterval(() => {
              if (this.countTime <= 1) {
                clearInterval(this.interval)
                this.countTime = 60
                this.isClickSMS = false
              } else {
                this.countTime--
              }
            }, 1000)
          } else {
            this.$message(res.msg)
            this.countTime = 60
            this.isClickSMS = false
          }
        })
      }
    },
    handleLogin() {
      if (this.isClickLogin) {
        return false
      }
      this.isClickLogin = true
      if (!isPhone(this.form.mobile)) {
        this.$message('请输入手机号')
        this.isClickLogin = false
        return
      }
      if (this.validation !== this.identifyCode) {
        this.$message('验证码错误')
        this.isClickLogin = false
        return
      }
      if (!this.form.sms_code) {
        this.$message('请输入验证码')
        this.isClickLogin = false
        return
      }
      login({ ...this.form }).then((res) => {
        console.log('login------------->', res)
        if (res.result === 1) {
          this.isClickLogin = false
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          this.$emit('saveGiftsUser', res)
          this.$emit('needLogin', false)
        } else {
          this.$message(res.msg)
          this.isClickLogin = false
        }
      })
      .catch((err) => {
        this.isClickLogin = false
        console.log(err)
      })
    }
  }
}
</script>
<style lang='less' scoped>
/deep/ .el-dialog {
  width: 720px;
  position: absolute;
  top: 160px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 30px 30px;
  border-radius: 30px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    .first-floor {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 25px;
      .label {
        flex: 1;
        height: 50px;
        padding: 0 10px;
        border: 1px solid #B8D4B4;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        &:nth-of-type(2) {
          margin-left: 20px;
        }
        .el-input__inner {
          border: 0;
          outline: none;
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #000;
        }
        .Validation {
          display: flex;
          align-items: center;
          canvas {
            width: 120px!important;
            height: 44px!important;
            border-radius: 22px;
            margin-right: -7px;
          }
        }
        .codeBtn {
          width: 160px;
          height: 44px;
          background: #4E8B46;
          border: 1px solid #4E8B46;
          border-radius: 22px;
          color: #fff;
          margin-right: -7px;
          font-size: 18px;
          font-family: FZLanTingHeiS-R-GB;
          font-weight: 400;
          color: #FFFFFF;
          :hover {
            color: #fff;
          }
          &.is-disabled {
            background: #ccc;
            border-color: #ccc;
          }
        }
      }
    }
    .loginBtn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 620px;
      height: 60px;
      background: #4E8B46;
      border-radius: 25px 25px 25px 25px;
      font-size: 32px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto 19px auto;
      cursor: pointer;
      -webkit-user-select: none;
      .el-icon-loading {
        font-size: 32px!important;
      } 
    }
    .register {
      font-size: 20px;
      font-family: FZLanTingHeiS-R-GB;
      font-weight: 400;
      color: #999999;
      margin: 0 auto;
      border-bottom: 1px solid #999;
      cursor: pointer;
      -webkit-user-select: none;
    }
  }
}
</style>